// ============================================================
// useTeacher Hook
// ============================================================

import { useEffect } from 'react';
import useTeacherStore from '@/store/teacherStore';
import { useSchool } from './useSchool';

export function useTeacher(teacherId) {
  const { schoolId } = useSchool();
  
  const currentTeacher = useTeacherStore((s) => s.currentTeacher);
  const loading = useTeacherStore((s) => s.loading);
  const error = useTeacherStore((s) => s.error);
  const fetchTeacherById = useTeacherStore((s) => s.fetchTeacherById);
  const clearCurrentTeacher = useTeacherStore((s) => s.clearCurrentTeacher);

  useEffect(() => {
    if (schoolId && teacherId) {
      fetchTeacherById(schoolId, teacherId);
    }
    return () => clearCurrentTeacher();
  }, [schoolId, teacherId, fetchTeacherById, clearCurrentTeacher]);

  return { teacher: currentTeacher, loading, error };
}
